const smartListConstants = {
    SMART_LIST_PRODUCTS: "SMART_LIST_PRODUCTS",
    SMART_LIST_PRODUCTS_REQUEST: "SMART_LIST_PRODUCTS_REQUEST",
    SMART_LIST_PRODUCTS_FAILURE: "SMART_LIST_PRODUCTS_FAILURE",
    SMART_LIST_PRODUCT_UPDATE_IS_FAV: "SMART_LIST_PRODUCT_UPDATE_IS_FAV",
    RESET_SMART_LIST_PRODUCTS: "RESET_SMART_LIST_PRODUCTS"
};

export default smartListConstants;